export default __webpack_public_path__ + "static/media/img_area_10.11f22207.svg";